import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit, OnDestroy {
  @ViewChild('editForm', { static: true }) editForm!: NgForm;
  userInfo: any;
  emailOrMobileNotFilled = true;
  formSub!: Subscription | undefined;
  constructor(
    private authService: AuthService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getCurrentUser();

    this.formSub = this.editForm.valueChanges?.subscribe((res) => {
      if (!res.emailId && !res.contactNumber) {
        this.emailOrMobileNotFilled = true;
      } else this.emailOrMobileNotFilled = false;
    });
  }
  ngOnDestroy(): void {
    if (this.formSub) this.formSub.unsubscribe();
  }

  getCurrentUser(): void {
    this.authService.apiGet('user', null).subscribe((res) => {
      this.userInfo = res;
      // Set values in form controls
      this.setValues();
    });
  }

  get controls() {
    return this.editForm.controls;
  }

  preventDash(ev: any): void {
    if (ev.key === '-' || ev.key === '.') ev.preventDefault();
  }

  onSubmit(form: NgForm): void {
    if (form.invalid) return;
    this.authService.apiPut('user', form.value).subscribe(
      (res) => {
        this.snackBar.open('Profile details updated successfully', '', {
          duration: 2000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom',
        });
        this.router.navigate(['/dashboard/my-profile']);
      },
      (err) => {
        // Show error in snackbar

        this.snackBar.open(
          err.error?.message ||
            'Something went wrong! please contact the administrator',
          '',
          { duration: 4000 }
        );
      }
    );
  }

  setValues(): void {
    this.editForm.form.patchValue(this.userInfo);
    this.editForm.form.patchValue({ emailId: this.userInfo.email });
  }
}
